import { cn } from "@/lib/utils"

/** A 0–5 rating as filled/hollow stars, rounded to the nearest whole star. */
export function Stars({ rating, className }: { rating: number; className?: string }) {
  const filled = Math.round(rating)
  return (
    <span
      className={cn("text-ember tracking-[0.1em]", className)}
      aria-label={`${rating} out of 5`}
    >
      {"★".repeat(Math.min(5, filled))}
      {"☆".repeat(Math.max(0, 5 - filled))}
    </span>
  )
}
